// TODO(i18n): Import translation functions from ttag
import React from "react";
import { IStoreSearchFilters } from "tsi-common-react/src/apps/retail/models.interfaces";
import {
    ILocation,
    IRetailStoreWithDistance,
} from "tsi-common-react/src/models/location.interfaces";

import { IFilterChangeHandler } from "../models.interfaces";
import { DistanceFilter } from "./LocatorFilters_Distance";
import { LocationFilter } from "./LocatorFilters_Location";
import { RetailerFilter } from "./LocatorFilters_Retailer";

interface IProps {
    filterValues: IStoreSearchFilters;
    currentLocation: ILocation | null;
    allStores: IRetailStoreWithDistance[];
    filteredStores: IRetailStoreWithDistance[];
    onChange: IFilterChangeHandler;
}

interface IState {}

// TODO(ssr, VERY_LOW 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to simple render-only component composing filter components with no state or lifecycle methods.
export class LocatorFilters extends React.Component<IProps, IState> {
    render() {
        // TODO(i18n): Use jt to interpolate JSX components into complete sentence. The complete sentence should be translated as one unit with placeholders for count, RetailerFilter, DistanceFilter, and LocationFilter components. Example: jt`${count} results for ${retailerFilter} within ${distanceFilter} of ${locationFilter} that carry Tempur-Pedic products.`
        return (
            <p className="filters__filters">
                <span className="filters__results">
                    <strong className="bh-sl-total-results">
                        {this.props.filteredStores.length}
                    </strong>{" "}
                    results
                </span>{" "}
                for{" "}
                <RetailerFilter
                    filterValues={this.props.filterValues}
                    onChange={this.props.onChange}
                    stores={this.props.allStores}
                />{" "}
                within{" "}
                <DistanceFilter
                    filterValues={this.props.filterValues}
                    onChange={this.props.onChange}
                />{" "}
                of{" "}
                <LocationFilter
                    filterValues={this.props.filterValues}
                    currentLocation={this.props.currentLocation}
                    onChange={this.props.onChange}
                />{" "}
                that carry Tempur-Pedic products.
            </p>
        );
    }
}
